export default function PrivacyPolicy() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>Privacy Policy</h1>
      
      <p>
        Your privacy is important to us. This app may collect device and usage information to improve app performance. 
        We do not collect personal information such as name, email, phone number, or financial data unless you explicitly provide it.
      </p>

      <p>
        We do not sell or share your information with third parties. Any data shared with service providers is non-personal 
        and used only to help improve the app.
      </p>

      <p>
        If the app requests access to sensitive permissions (e.g., storage), it will be clearly explained and used only with your consent.
      </p>

      <p>
        Our app is not directed to children under 13, and we do not knowingly collect data from them.
      </p>

      <p>
        For questions or requests regarding your data, please contact us at: idea2realitysoftware@gmail.com
      </p>
    </div>
  );
}
